var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPointsElement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57.286236,
    height: 42.185188,
    viewBox: "0 0 57.286238 42.185187",
    id: "svg1067",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1071"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#362d41",
      fillOpacity: 1,
      strokeWidth: 1.88976,
      paintOrder: "stroke fill markers"
    },
    d: "M 0.58209079,0.3842994 7.9484175e-7,41.442559 57.194141,42.185189 57.286241,-5.9894004e-7 Z",
    id: "path288"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointsElement);
export default __webpack_public_path__ + "static/media/PointsElement.dea57fd70584b22c511d87a26c457299.svg";
export { ForwardRef as ReactComponent };